import {Component, forwardRef, HostBinding, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonTextareaBaseComponent} from '../../../core/ion-components/ionTextarea';

@Component({
  selector: 'app-textarea',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ]
})

/**
 * Usage:
 * ```
 * ```
 *
 * Configurable params:
 *  - type
 */
export class TextareaComponent extends IonTextareaBaseComponent implements OnInit {

  hasFocus = false;

  @Input() labelText?: string;
  @Input() size: 'medium' | 'large' = 'medium';
  @Input() state: 'success' | 'error';
  @Input() showErrorElement = true;
  @Input() errorText: string;
  @Input() errorTextPosition: 'left' | 'right' | 'center' = 'left';
  @Input() onlyNumbers = false;
  @Input() clearInput: boolean;
  @Input() requiredLabel = false;

  @HostBinding('class')
  get classes() {
    return {
      [`input-state-${this.state}`]: this.state,
      [`input-size-${this.size}`]: this.size,
      'input-disabled': this.disabled,
      'input-clear-on-edit': this.clearInput
    };
  }

  ngOnInit() {

  }

  clear(event: any) {
    event.stopPropagation();

    this.value = null;

    this.changeModelEvent.emit(this.value);
    this.onTouchModel();
  }

  onBlur(event: CustomEvent<FocusEvent> | any) {
    super.onBlur(event);

    this.hasFocus = false;
  }

  onFocus(event: CustomEvent<FocusEvent> | any) {
    super.onFocus(event);

    this.hasFocus = true;
  }
}
